import { useState } from 'react';
import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES, ERROR_CODES } from '../../../constants';
import { TAPIResponse } from '../../../api.types';

export type TAPIIdentityDeveloperEmailResponse = {
  isUnique: boolean
};

export type TAPIResponseIdentityDeveloperEmail = TAPIResponse & {
  identityDeveloperEmail(email: string): Promise<TAPIIdentityDeveloperEmailResponse>;
};

export const useAPIIdentityDeveloperEmail = (): TAPIResponseIdentityDeveloperEmail => {
  const [responseData, setResponseData] = useState<TAPIIdentityDeveloperEmailResponse>({ isUnique: false });
  const { get, response, loading, error } = useFetch(API_ROUTES.DEVELOPERS, {
    cachePolicy: CachePolicies.NO_CACHE
  });

  async function identityDeveloperEmail(email: string): Promise<TAPIIdentityDeveloperEmailResponse> {
    const serverResponse = await get(`/check-email?email=${encodeURIComponent(email)}`);

    const isUnique = serverResponse.data?.code !== ERROR_CODES.EMAIL_UNIQUES;

    if (response.ok) {
      setResponseData({ isUnique });
    }

    return Promise.resolve({ isUnique });
  }

  return {
    loading,
    error,
    data: responseData,
    loaded: response.ok,
    identityDeveloperEmail,
  };
};
